<template>
  <div>
    <el-dialog
      title="模块列表"
      :visible="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="90%"
    >
      <el-row>
        <el-form label-width="80px" label-position="left">
          <el-form-item label="选择集成">
            <el-select style="width: 24%;"
              v-model="unitId"
              filterable
              :filter-method="filterIntergrationOption"
              @change="selectUnit(unitId)"
            >
              <!-- <el-option label="全部" value="-1">全部</el-option> -->
              <el-option v-for="unit in integrationListFilter"
                :key="unit.id"
                :label="unit.alias"
                :value="unit.id">
                <span style="float: left">{{ unit.alias }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ unit.version }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字" style="width:30%;">
            <el-input placeholder="输入关键字搜索" :disabled="searchDisabled" v-model="search"></el-input>
          </el-form-item>
        </el-form>
      </el-row>
      <!-- <el-row style="margin-bottom: 20px;">
        <el-col :span="6">
          <el-input placeholder="输入关键字搜索" prefix-icon="el-icon-search" v-model="search"></el-input>
        </el-col>
      </el-row> -->
      <el-row>
        <el-col
          :span="5"
          v-for="(item, index) in filterArray"
          :key="index"
          style="margin-bottom:5px;width: 25%;"
        >
          <div @click="handleCheckedChange(item, index, $event)" class="divChecked">
            <el-card
              :body-style="{ padding: '0px'}"
              :class="{active:index == active}"
              shadow="hover"
              :offset="1"
              style="width: 85%;height: 100%;cursor:pointer;"
            >
              <div>
                <module :item="item" />
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <h3>配置文件</h3>
        <config-list type="modulelist" :moduleInfo="current" @uploadCallback="uploadCallback"/>
      </el-row>
      <el-row style="text-align:center;margin-top:20px;">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="cancelCallback">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import Module from "./Module.vue";
import ConfigList from "./ConfigList.vue";
export default {
  name: "ModuleList",
  components: { Module, ConfigList },
  props: {
    visible: {
      type: Boolean
    },
    deviceId: {
      type: Number
    }
  },
  data: vm => ({
    active: null,
    area: "全部",
    engineRoom: "全部",
    search: "",
    option: {
      area: [{ label: "全部", value: "全部" }],
      engineRoom: [{ label: "全部", value: "全部" }]
    },
    moduleArray: [], //模块列表
    allModule: [],
    current: {},
    unitId: '', //集成
    UnitList: [],
    unitInfo: {},
    searchDisabled: false,
    integrationListFilter: []
  }),
  mounted() {
    // this.findAll();
    if(this.deviceId){
      this.search = 'service_agent'
      this.searchDisabled = true
    }
    this.findIntegration()
  },
  computed: {
    filterArray() {
      return this.filterArr(this.search, this.moduleArray)
    }
  },
  methods: {
    // 查询集成列表
    findIntegration(){
      this.$axios
        .get(this.moduleUrl + "integration/Version/findAll")
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            this.UnitList = data ? data : [];
            this.integrationListFilter = data ? data : []
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
        }).catch(err=>{
          console.log('获取集成-请求失败')
        });
    },
    // 选择集成后，显示该集成下的模块
    selectUnit(unitId){
      this.unitInfo = this.UnitList.filter(u => u.id == unitId)[0]
      this.moduleArray = []
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });
      this.$axios
        .get(this.moduleUrl + "integration/Version/" + this.unitInfo.alias + "/" + this.unitInfo.version)
        .then(({ data: { msg, data, code } }) => {
          if (code == 20000) {
            // this.moduleArray = data.moduleList ? data.moduleList : []
            if(data.moduleList && data.moduleList.length > 0){
              data.moduleList.forEach(element => {
                this.moduleArray.push({
                  name: element.moduleName,
                  alias: element.moduleAlias,
                  id: element.moduleId,
                  versionId: element.moduleVersionId,
                  version: element.moduleVersion,
                  hasServiceHelper: element.hasServiceHelper
                })
              });
            }
          } else {
            this.$message({ showClose: true, message: msg, type: "error" });
            console.log(msg);
          }
          loading.close();
        })
        .catch(err =>{
          console.log(err);
          loading.close();
        });
    },
    uploadCallback(val){
      this.current.configs = val
    },
    /**
     * 选中设备时,显示设备详细信息
     * @param val
     */
    handleCheckedChange(row, index, e) {
      this.active = index;
      this.current = row;
    },
    // findAll() {
    //   let loading = Loading.service({
    //     fullscreen: true,
    //     text: "数据加载中..."
    //   });
    //   this.$axios
    //     .get(this.moduleUrl + "moduleVersion/findAllByPage/1/1000")
    //     .then(({ data: { msg, data, code } }) => {
    //       if (code == 20000) {
    //         this.moduleArray = data.list ? data.list : []
    //         this.allModule = data.list ? data.list : []
    //       } else {
    //         this.$message({ showClose: true, message: msg, type: "error" });
    //         console.log(msg);
    //       }
    //       loading.close();
    //     });
    // },
    save() {
      this.current.type = "module";
      // 集成信息
      this.current.unitInfo = this.unitInfo
      this.$emit("chooseCallback", this.current);
    },
    cancelCallback() {
      this.$emit("cancelCallback", "showModule");
    },
    filterIntergrationOption(val){
        const allOptions = [...this.UnitList]
        if(!val){
            this.integrationListFilter = allOptions
        }else{
            this.integrationListFilter = allOptions.filter(option => option.alias.toLowerCase().indexOf(val.toLowerCase()) > -1 )
        }
    },
  }
};
</script>
<style scoped>
.divChecked .active {
  background-color: #409eff;
  border-color: #ff2021;
  border: 3px solid #ff2021;
  margin: -2px 0px;
  /*border-width:1px 3px;*/
}

.divCheckedNetwork .active {
  background-color: #409eff;
  border-color: #ff2021;
}
</style>
